module.exports = __webpack_public_path__ + "img/hero-1.92e88b84.png";